import { CompetitionCard } from '@/core/blocks';
import { Skeleton, Typography } from '@/core/ui';
import { API } from '@/store/api';
import { ValueNoneIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'react-i18next';

export const CompetitionList = ({ competitionType }: { competitionType: string | null }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('translation');

  const {
    error,
    isLoading,
    isFetching,
    data,
  } = API.cupApi.useGetCupCompetitionsQuery(
    {
      competition_type: competitionType ?? 'national',
      locale: i18n.language,
    },
    { skip: !competitionType || !i18n.language },
  );

  if (error) {
    return <>Something went wrong!</>;
  }

  if (isLoading || isFetching || !data || !competitionType) {
    return (
      <div className='grid grid-cols-4 gap-7'>
        {Array.from({ length: 17 }).map((_, index) => (
          <div key={index} className='w-[290px] h-[108px] rounded-[17px]'>
            <Skeleton className='col-span-1 w-full h-full bg-chalk/10' />
          </div>
        ))}
      </div>
    );
  }

  if (competitionType === 'Walking Football' && data.walking_football) {
    const walking = data.walking_football;
    return (
      <div className='flex flex-col items-start space-y-11'>
        <img
          src={walking.logo.path}
          alt={walking.logo.caption || 'Walking Football Logo'}
          className='w-[430px] h-[175px] object-cover'
        />
        <Typography
          className='w-[1222px] text-white text-[21px]'
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: walking.description }}
        />
      </div>
    );
  }

  if (!data.national_competitions || !data.national_competitions.length) {
    return (
      <div className='w-full flex-col space-y-8 text-center flex justify-center items-center'>
        <ValueNoneIcon className='text-white w-24 h-24' />
        <Typography className='text-chalk text-4xl capitalize'>{t('cups.no_competitions')}</Typography>
      </div>
    );
  }

  return (
    <div className='grid grid-cols-4 gap-7'>
      {data.national_competitions.map((p) => (
        <CompetitionCard
          competitionId={p.id}
          logo={p.logo.path}
          className='col-span-1'
          key={p.id}
          name={p.name}
          link={p.has_details}
        />
      ))}
    </div>
  );
};
